import styled from 'styled-components';


export const FichaComponent = styled.div.attrs({
    className: ``
})`
    display: flex;
    justify-content: center;

`